import { withConfig } from "src/withConfig";
import styled from '@emotion/styled';
import { Iframe } from "src/domains/layouts/webview/components/Iframe";

export const HeaderWrapper = withConfig(theme => styled('header', { label: 'HeaderWrapper' })`
    align-items: center;
    background: ${theme.star.casino.bgColorTertiary};
    display: flex;
    height: 56px;
    padding: 0 16px;
    width: 100%;
    flex-shrink: 0;
`);

interface ModalWrapperPropsType {
    isDepositOpened: boolean;
}

export const ModalWrapper = withConfig(theme => styled('div', { label: 'ModalWrapper' })<ModalWrapperPropsType>`
    padding: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${({ isDepositOpened }): number => isDepositOpened ? theme.star.zIndexGlobal.below + theme.star.zIndexGlobal.rhsMenu : theme.star.zIndexGlobal.highLevel};
`);

export const GameContentWrapper = styled('div', { label: 'GameContentWrapper' })`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const IframeContainer = styled('div', { label: 'IframeContainer' })`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const GameIframe = styled(Iframe, { label: 'GameIframe' })`
    width: 100%;
    height: 100%;
    border: 0;
`;

